"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { schemaWithTitle } from '@integration-app/sdk';
import { DataInput } from '../../DataInput/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { Formula, Variable, VariableSvgIcon } from '../../Formula/index.mjs';
import useDataBuilderField from '../field-context.mjs';
import { DrilldownBlockContentWrapper } from '../../DataBuilderUI/index.mjs';

const FirstNotEmptyFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsx(Formula, { ref, onClick: props.onClick, children: /* @__PURE__ */ jsxs(Variable, { children: [
      /* @__PURE__ */ jsx(VariableSvgIcon, { type: SvgIconType.Function }),
      " First not empty"
    ] }) });
  }
);
FirstNotEmptyFormula.displayName = "FirstNotEmptyFormula";
function FirstNotEmptyDropdown({ onChange, formula }) {
  const { field, localSchema } = useDataBuilderField();
  const renderedField = {
    ...field,
    value: {
      $firstNotEmpty: formula.args
    }
  };
  return /* @__PURE__ */ jsx(FirstNotEmptyNested, { field: renderedField, onChange, schema: localSchema });
}
function FirstNotEmptyNested({ field, onChange, schema }) {
  return /* @__PURE__ */ jsx(DrilldownBlockContentWrapper, { children: /* @__PURE__ */ jsx(
    DataInput,
    {
      schema: schemaWithTitle(
        {
          type: "array",
          items: schema
        },
        "Values"
      ),
      value: field.value?.$firstNotEmpty ?? [],
      variablesSchema: field.variablesSchema,
      onChange: (value) => {
        onChange?.({ $firstNotEmpty: value });
      }
    }
  ) });
}

export { FirstNotEmptyDropdown, FirstNotEmptyFormula as default };
